/* DZ-VM-FUNNEL (2026-09-05): app-free quantity-break bundle picker for the Curious Kids single-book pages.
   The bars are static markup (built from the live Kaching widget on vamorastore.co); this script keeps the
   selected state, and on Add to cart adds <quantity> x the product variant through /cart/add.js and opens the
   DayDreamz cart drawer. Pricing comes from the store's automatic quantity discounts. No GemPages / Kaching app. */
(function () {
  "use strict";
  function ready(fn) { document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }
  ready(function () {
    // in-page "2,000+ reviews" links: scroll to the reviews section ourselves (the PHX Navigation API intercept
    // swallows same-page hash navigations)
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#shopify-section-"]');
      if (!a) return;
      var target = document.getElementById(a.getAttribute("href").slice(1));
      if (!target) return;
      e.preventDefault(); e.stopImmediatePropagation();
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }, true);
    var block = document.querySelector(".kaching-bundles__block");
    if (!block) return;
    var variantId = parseInt(block.getAttribute("data-variant-id"), 10);
    var radios = block.querySelectorAll('input[type="radio"][name^="kaching-bundles-deal"]');
    radios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        block.querySelectorAll(".kaching-bundles__bar").forEach(function (bar) {
          bar.classList.toggle("kaching-bundles__bar--selected", bar.querySelector('input[type="radio"]') === radio && radio.checked);
        });
      });
    });
    function selectedQty() {
      var bar = block.querySelector(".kaching-bundles__bar--selected");
      return bar ? (parseInt(bar.getAttribute("data-quantity"), 10) || 1) : 1;
    }
    var form = block.closest("form") || document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var atcBtn = form.querySelector('button[name="add"]');
    function setLoading(on) { if (atcBtn) { atcBtn.classList.toggle("gp-button-loading", on); atcBtn.disabled = on; } }
    function openDrawer(parsed) {
      var drawer = document.querySelector("cart-drawer");
      if (drawer && typeof drawer.renderContents === "function" && parsed.sections) drawer.renderContents(parsed);
      else if (drawer && typeof drawer.open === "function") drawer.open();
      else window.location.href = "/cart";
    }
    function addItems(items) {
      setLoading(true);
      var sections = ["cart-drawer", "cart-icon-bubble"];
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: items, sections: sections.join(","), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (parsed) {
        if (parsed.status && parsed.status !== 200) { console.error("Add to cart failed:", parsed.description || parsed.message); return; }
        openDrawer(parsed);
      }).catch(function (e) { console.error("Add to cart error:", e); }).finally(function () { setLoading(false); });
    }
    function intercept(e) {
      if (!variantId) return;
      e.preventDefault(); e.stopImmediatePropagation();
      addItems([{ id: variantId, quantity: selectedQty() }]);
    }
    if (atcBtn) atcBtn.addEventListener("click", intercept, true);
    form.addEventListener("submit", intercept, true);
  });
})();
